import { ASSET_DIR, STRINGS } from '@/constants/farmerSolutions'

import Picture from '../picture'
import Tick from '../svg/Tick'
import BannerHeader from './BannerHeader'
import VisitWebsite from './VisitWebsite'

interface WebsiteExperienceProps {
  label: string
}

const WebsiteExperience = ({ label }: WebsiteExperienceProps) => (
  <li className="flex items-center">
    <Tick className="fill-success-100 stroke-white h-6 w-6 mr-4" />
    <p className="text-base font-natosans-medium text-neutral-90">{label}</p>
  </li>
)

const KisanAppBanner = () => {
  return (
    <section className="bg-secondary-one-10 relative md:mt-20 mt-8">
      <section className="px-6 max-w-7xl m-auto grid grid-cols-1 md:grid-cols-2 items-center relative z-10">
        <Picture
          pictureStyle="md:block hidden"
          image={`${ASSET_DIR}/kisan-app-snapshots`}
          hasPng
          imageAlt="Feature images from Farmer web application"
          imageStyle="h-full"
        />
        <article className="md:pl-12 lg:mt-0 pt-8 pb-6">
          <BannerHeader />
          <ul className="space-y-4 mt-4 md:mb-5 mb-6">
            <WebsiteExperience label={STRINGS.EASY_BROWSING_EXPERIENCE} />
            <WebsiteExperience label={STRINGS.QUICK_ACCESS} />
          </ul>
          <VisitWebsite />
        </article>
      </section>
      <Picture
        className="absolute bottom-0 right-0 aspect-square h-60 z-0"
        pictureStyle="hidden md:block"
        image={`${ASSET_DIR}/banner-ellipse`}
        hasPng
        imageAlt="Banner ellipse"
        role="presentation"
        aria-hidden
      />
      <Picture
        className="absolute top-0 right-0 h-[140px] w-[120px] z-0"
        pictureStyle="md:hidden"
        image={`${ASSET_DIR}/banner-ellipse-mobile`}
        hasPng
        imageAlt="Mobile Banner ellipse"
        role="presentation"
        aria-hidden
      />
    </section>
  )
}

export default KisanAppBanner
